import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import Navbar from '@/components/Navbar';
import TowerSelectPage from '@/pages/TowerSelectPage';
import HomePage from '@/pages/HomePage';
import FloorplanView from '@/pages/FloorplanView';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import SuperAdminCMS from '@/pages/SuperAdminCMS';
import BuildingStructure from '@/pages/BuildingStructure';
import '@/App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F7]">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={
        <>
          <Navbar transparent />
          <TowerSelectPage />
        </>
      } />
      <Route path="/tower/:towerId" element={
        <>
          <Navbar transparent />
          <HomePage />
        </>
      } />
      <Route path="/tower/:towerId/floor/:floor" element={
        <>
          <Navbar />
          <FloorplanView />
        </>
      } />
      <Route path="/admin" element={
        user ? <Navigate to="/admin/dashboard" replace /> : (
          <>
            <Navbar />
            <AdminLogin />
          </>
        )
      } />
      <Route path="/admin/dashboard" element={
        <ProtectedRoute>
          <Navbar />
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/cms" element={
        <ProtectedRoute>
          <Navbar />
          <SuperAdminCMS />
        </ProtectedRoute>
      } />
      <Route path="/admin/structure" element={
        <ProtectedRoute>
          <Navbar />
          <BuildingStructure />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
